"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionID = exports.AppID = void 0;
var _uuid = require("uuid");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DELIMITER = "~";
var SESSIONID_DELIMITER = "+";
var AppID = exports.AppID = /*#__PURE__*/function () {
  function AppID(value) {
    _classCallCheck(this, AppID);
    this.value = value;
  }
  return _createClass(AppID, [{
    key: "createNewSessionID",
    value: function createNewSessionID() {
      return new SessionID(this.value + DELIMITER + (0, _uuid.v4)());
    }
  }]);
}();
var SessionID = exports.SessionID = /*#__PURE__*/function () {
  function SessionID(value) {
    _classCallCheck(this, SessionID);
    this.value = value;
  }
  return _createClass(SessionID, [{
    key: "getAppID",
    value: function getAppID() {
      var index = this.value.indexOf(DELIMITER);
      if (index < 0) {
        return undefined;
      }
      return new AppID(this.value.substring(0, index));
    }
  }, {
    key: "prefixMsg",
    value: function prefixMsg(msg) {
      return this.value + SESSIONID_DELIMITER + JSON.stringify(msg);
    }
  }]);
}();